(function() {
  function findAttr(node, attr) {
    while (node && node !== document) {
      if (node.getAttribute && node.getAttribute(attr) !== null) return node;
      node = node.parentNode;
    }
    return null;
  }
  function findMatch(node, selectorCheck) {
    while (node && node !== document) {
      if (selectorCheck(node)) return node;
      node = node.parentNode;
    }
    return null;
  }
  function hasClass(node, cls) { return node.classList && node.classList.contains(cls); }
  function hasId(node, id) { return node.id === id; }

  var header = document.getElementById('header');
  var announcement = document.querySelector('.announcement');
  var mobileNav = document.getElementById('mobileNav');
  var selectedRating = 0;

  // ===== SHOPIFY CHECKOUT CONFIG =====
  // To route orders through Shopify's real checkout (automatic order emails to you + the
  // customer, Cash on Delivery, inventory, order records), fill in your store domain and
  // each product's variant ID below. While SHOPIFY_STORE is empty, the built-in
  // cash-on-delivery form is used instead (which emails you via Formspree).
  var SHOPIFY_STORE = 'layers-8937.myshopify.com'; // e.g. 'layers-8937.myshopify.com'  (no https://)
  var SHOPIFY_VARIANTS = {
    'Little Italy': '53409627472235',
    'Dolce Vita': '53409628684651',
    'Il Quartetto (4x Little Italy)': '53409633665387',
    'Il Quartetto (4x Dolce Vita)': '53409634517355',
    'La Tavolata (6x Little Italy)': '53409635697003',
    'La Tavolata (6x Dolce Vita)': '53409637237099'
  };

  function goTo(page, scrollTo) {
    var pages = document.querySelectorAll('.page');
    for (var i = 0; i < pages.length; i++) pages[i].classList.remove('active');

    if (page === 'latenights') {
      document.getElementById('page-latenights').classList.add('active');
      header.className = 'header scrolled force-solid';
      announcement.classList.add('hidden');
      window.scrollTo(0,0); return;
    }
    if (page === 'faq') {
      document.getElementById('page-faq').classList.add('active');
      header.className = 'header scrolled force-solid';
      announcement.classList.add('hidden');
      window.scrollTo(0,0); return;
    }
    if (page === 'order') {
      document.getElementById('page-order').classList.add('active');
      header.className = 'header scrolled force-solid';
      announcement.classList.add('hidden');
      window.scrollTo(0,0); return;
    }
    document.getElementById('page-home').classList.add('active');
    header.classList.remove('force-solid');
    if (scrollTo) {
      header.className = 'header scrolled';
      setTimeout(function(){ var el = document.getElementById(scrollTo); if(el) el.scrollIntoView({behavior:'smooth',block:'start'}); }, 50);
    } else {
      window.scrollTo(0,0);
      header.className = 'header';
      announcement.classList.remove('hidden');
    }
  }

  // -- CART STATE --
  var cart = [];
  var cartOverlay = document.getElementById('cartOverlay');
  var cartPanel = document.getElementById('cartPanel');
  var cartBody = document.getElementById('cartBody');
  var cartEmpty = document.getElementById('cartEmpty');
  var cartFoot = document.getElementById('cartFoot');
  var cartTotal = document.getElementById('cartTotal');
  var cartBadge = document.getElementById('cartBadge');
  var cartToast = document.getElementById('cartToast');

  // -- CLEAR CART --
  var clearCartBtn = document.createElement('button');
  clearCartBtn.type = 'button';
  clearCartBtn.className = 'cart-clear';
  clearCartBtn.textContent = 'Clear cart';
  clearCartBtn.onclick = function() { cart = []; renderCart(); };
  if (cartFoot) cartFoot.appendChild(clearCartBtn);
  var toastTimer;

  function showCartView() {
    document.getElementById('cartHead').style.display = 'flex';
    cartBody.style.display = 'block';
    document.getElementById('checkoutView').classList.remove('active');
    if (cart.length > 0) cartFoot.style.display = 'block';
    // reset checkout form/success for next time
    document.getElementById('checkoutFields').style.display = 'block';
    document.getElementById('checkoutSuccess').classList.remove('show');
  }

  function openCart() { cartOverlay.classList.add('open'); cartPanel.classList.add('open'); showCartView(); }
  function closeCart() { cartOverlay.classList.remove('open'); cartPanel.classList.remove('open'); }

  function goToShopifyCheckout() {
    if (cart.length === 0) return;
    var items = [], parts = [];
    for (var i = 0; i < cart.length; i++) {
      var vid = SHOPIFY_VARIANTS[cart[i].name];
      if (vid) { items.push({ id: vid, quantity: cart[i].qty }); parts.push(vid + ':' + cart[i].qty); }
    }
    // if variant IDs aren't filled in yet, fall back to the built-in COD form
    if (items.length === 0) { openCheckout(); return; }
    // Primary: add everything to Shopify's real cart, then go straight to checkout.
    // (Relative URLs work because this page runs on your Shopify store.)
    if (window.fetch) {
      fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .then(function(){
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          });
        })
        .then(function(){ window.location.href = '/checkout'; })
        .catch(function(){ window.location.href = 'https://' + SHOPIFY_STORE + '/cart/' + parts.join(','); });
    } else {
      window.location.href = 'https://' + SHOPIFY_STORE + '/cart/' + parts.join(',');
    }
  }

  function openCheckout() {
    if (cart.length === 0) return;
    // hide cart view, show checkout
    document.getElementById('cartHead').style.display = 'none';
    cartBody.style.display = 'none';
    cartFoot.style.display = 'none';
    document.getElementById('checkoutView').classList.add('active');
    document.getElementById('checkoutFields').style.display = 'block';
    document.getElementById('checkoutSuccess').classList.remove('show');
    renderCheckoutSummary();
  }

  function renderCheckoutSummary() {
    var summary = document.getElementById('checkoutSummary');
    var total = 0;
    var html = '';
    for (var i = 0; i < cart.length; i++) {
      total += cart[i].qty * cart[i].price;
      html += '<div class="co-row"><div class="co-row-left">' + cart[i].name + '<span>x' + cart[i].qty + '</span></div>' +
              '<div class="co-row-price">EGP ' + (cart[i].qty * cart[i].price) + '</div></div>';
    }
    summary.innerHTML = html;
    document.getElementById('checkoutTotal').textContent = 'EGP ' + total;
  }

  function placeOrder() {
    var name = (document.getElementById('co-name')||{}).value || '';
    var phone = (document.getElementById('co-phone')||{}).value || '';
    var area = (document.getElementById('co-area')||{}).value || '';
    var address = (document.getElementById('co-address')||{}).value || '';
    var notes = (document.getElementById('co-notes')||{}).value || '';

    // basic validation
    if (!name || !phone || !area || !address) {
      alert('Please fill in your name, phone, area, and address so we can deliver your order.');
      return;
    }

    var total = 0, itemsText = '';
    for (var i = 0; i < cart.length; i++) {
      total += cart[i].qty * cart[i].price;
      itemsText += cart[i].qty + ' x ' + cart[i].name + ' (EGP ' + (cart[i].qty * cart[i].price) + ')\n';
    }

    var payload = {
      _subject: 'Layers Order - Cash on Delivery',
      Order: itemsText,
      Total: 'EGP ' + total,
      Payment: 'Cash on Delivery',
      Name: name,
      Phone: phone,
      Area: area,
      Address: address,
      Notes: notes
    };

    // show confirmation
    document.getElementById('checkoutFields').style.display = 'none';
    document.getElementById('checkoutSuccess').classList.add('show');

    // send to email via Formspree
    try {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', 'https://formspree.io/f/mbdvrvqw', true);
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send(JSON.stringify(payload));
    } catch (err) {}

    // clear the cart so badge resets
    cart = [];
    renderCart();
  }

  function showToast(msg) {
    cartToast.textContent = msg;
    cartToast.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){ cartToast.classList.remove('show'); }, 2000);
  }

  function addToCart(name, price, qty) {
    var found = false;
    for (var i = 0; i < cart.length; i++) {
      if (cart[i].name === name) { cart[i].qty += qty; found = true; break; }
    }
    if (!found) cart.push({ name: name, price: price, qty: qty });
    renderCart();
    showToast(qty + ' x ' + name + ' added to cart');
  }

  function removeFromCart(name) {
    for (var i = 0; i < cart.length; i++) {
      if (cart[i].name === name) { cart.splice(i, 1); break; }
    }
    renderCart();
  }

  function changeCartQty(name, delta) {
    for (var i = 0; i < cart.length; i++) {
      if (cart[i].name === name) {
        cart[i].qty += delta;
        if (cart[i].qty < 1) cart.splice(i, 1);
        break;
      }
    }
    renderCart();
  }

  function renderCart() {
    var count = 0, total = 0;
    for (var i = 0; i < cart.length; i++) { count += cart[i].qty; total += cart[i].qty * cart[i].price; }

    if (count > 0) { cartBadge.textContent = count; cartBadge.classList.add('show'); }
    else { cartBadge.classList.remove('show'); }

    if (cart.length === 0) {
      cartEmpty.style.display = 'block';
      cartFoot.style.display = 'none';
      // remove any rendered items
      var olds = cartBody.querySelectorAll('.cart-item');
      for (var k = 0; k < olds.length; k++) olds[k].parentNode.removeChild(olds[k]);
      return;
    }

    cartEmpty.style.display = 'none';
    cartFoot.style.display = 'block';
    cartTotal.textContent = 'EGP ' + total;

    // clear old items
    var existing = cartBody.querySelectorAll('.cart-item');
    for (var m = 0; m < existing.length; m++) existing[m].parentNode.removeChild(existing[m]);

    // render each item
    for (var j = 0; j < cart.length; j++) {
      var item = cart[j];
      var div = document.createElement('div');
      div.className = 'cart-item';
      div.innerHTML =
        '<div class="cart-item-img"><div class="ph-ln"></div></div>' +
        '<div class="cart-item-info">' +
          '<div class="cart-item-name">' + item.name + '</div>' +
          '<div class="cart-item-price">EGP ' + item.price + '</div>' +
          '<div class="cart-item-controls">' +
            '<button type="button" class="cart-qty-btn" data-cart-minus="' + item.name + '">-</button>' +
            '<span class="cart-qty-num">' + item.qty + '</span>' +
            '<button type="button" class="cart-qty-btn" data-cart-plus="' + item.name + '">+</button>' +
            '<button type="button" class="cart-item-remove" data-cart-remove="' + item.name + '">Remove</button>' +
          '</div>' +
        '</div>';
      cartBody.appendChild(div);
    }
  }

  document.addEventListener('click', function(e) {
    var node = e.target;

    // Cart open/close
    if (findAttr(node, 'data-newsletter')) { e.preventDefault(); var ni = document.getElementById('nl-email'); var nv = ni ? ni.value.trim() : ''; if (!nv || nv.indexOf('@') === -1) { alert('Please enter a valid email.'); return; } try { var nx = new XMLHttpRequest(); nx.open('POST', 'https://formspree.io/f/mbdvrvqw', true); nx.setRequestHeader('Content-Type', 'application/json'); nx.setRequestHeader('Accept', 'application/json'); nx.send(JSON.stringify({ _subject: 'Layers Newsletter Signup', Email: nv })); } catch (err) {} if (ni) ni.value = ''; showToast("You're on the list"); return; }
    if (findAttr(node, 'data-cart-open')) { e.preventDefault(); openCart(); return; }
    if (findMatch(node, function(x){ return hasClass(x,'cart-close'); })) { closeCart(); return; }
    if (findMatch(node, function(x){ return hasId(x,'cartOverlay'); })) { closeCart(); return; }

    // Checkout flow
    if (findAttr(node, 'data-checkout')) { e.preventDefault(); if (SHOPIFY_STORE) { goToShopifyCheckout(); } else { openCheckout(); } return; }
    if (findMatch(node, function(x){ return hasId(x,'checkoutBack'); })) { e.preventDefault(); showCartView(); return; }
    if (findAttr(node, 'data-place-order')) { e.preventDefault(); placeOrder(); return; }

    // Cart item controls
    var cm = findAttr(node, 'data-cart-minus');
    if (cm) { e.preventDefault(); changeCartQty(cm.getAttribute('data-cart-minus'), -1); return; }
    var cp = findAttr(node, 'data-cart-plus');
    if (cp) { e.preventDefault(); changeCartQty(cp.getAttribute('data-cart-plus'), 1); return; }
    var cr = findAttr(node, 'data-cart-remove');
    if (cr) { e.preventDefault(); removeFromCart(cr.getAttribute('data-cart-remove')); return; }

    // Bundle flavour selector (works for any bundle card)
    var flavorEl = findAttr(node, 'data-flavor');
    if (flavorEl) {
      e.preventDefault();
      var opts = flavorEl.parentNode.querySelectorAll('.bundle-flavor-btn');
      for (var fo = 0; fo < opts.length; fo++) opts[fo].classList.remove('active');
      flavorEl.classList.add('active');
      var fPrice = flavorEl.getAttribute('data-price');
      var fWas = flavorEl.getAttribute('data-was');
      var fName = flavorEl.getAttribute('data-name');
      // find the parent bundle card, then update its price/was/add button
      var card = findMatch(flavorEl, function(x){ return hasClass(x,'bundle-card'); });
      if (card) {
        var priceEl = card.querySelector('.bundle-price');
        var wasEl = card.querySelector('.bundle-was');
        var addBtn = card.querySelector('[data-add]');
        if (priceEl) priceEl.textContent = 'EGP ' + fPrice;
        if (wasEl) wasEl.textContent = 'EGP ' + fWas;
        if (addBtn) { addBtn.setAttribute('data-price', fPrice); addBtn.setAttribute('data-add', fName); } var bp = card.querySelector('.bundle-photo'); var di = flavorEl.getAttribute('data-img'); if (bp && di) bp.src = di;
      }
      return;
    }

    // Add to cart
    var buyEl = findAttr(node, 'data-buynow'); if (buyEl) { e.preventDefault(); var srcAdd = buyEl.parentNode.querySelector('[data-add]'); if (!srcAdd) return; var bName = srcAdd.getAttribute('data-add'); var bPrice = parseInt(srcAdd.getAttribute('data-price'), 10); var qn = buyEl.parentNode.querySelector('.o-qty-num') || buyEl.parentNode.querySelector('.ln-qty-num'); var bQty = qn ? parseInt(qn.textContent, 10) : 1; var bf=false; for(var bi=0;bi<cart.length;bi++){if(cart[bi].name===bName){cart[bi].qty+=bQty;bf=true;break;}} if(!bf)cart.push({name:bName,price:bPrice,qty:bQty}); renderCart(); if (qn) qn.textContent = '1'; if (SHOPIFY_STORE) { goToShopifyCheckout(); } else { openCart(); openCheckout(); } return; }
var addEl = findAttr(node, 'data-add');
    if (addEl) {
      e.preventDefault();
      var aName = addEl.getAttribute('data-add');
      var aPrice = parseInt(addEl.getAttribute('data-price'), 10);
      var card = addEl.parentNode;
      var qtyNum = card.querySelector('.o-qty-num') || card.querySelector('.ln-qty-num');
      var aQty = qtyNum ? parseInt(qtyNum.textContent, 10) : 1;
      addToCart(aName, aPrice, aQty);
      if (qtyNum) qtyNum.textContent = '1';
      return;
    }

    // Star rating selector
    var starEl = findAttr(node, 'data-star');
    if (starEl) {
      e.preventDefault();
      selectedRating = parseInt(starEl.getAttribute('data-star'), 10);
      var stars = document.querySelectorAll('#revStars .rev-star');
      for (var s = 0; s < stars.length; s++) {
        if (s < selectedRating) stars[s].classList.add('active');
        else stars[s].classList.remove('active');
      }
      return;
    }

    var toggleEl = findAttr(node, 'data-toggle');
    if (toggleEl) {
      e.preventDefault();
      var formId = toggleEl.getAttribute('data-toggle');
      var formEl = document.getElementById(formId);
      var wasOpen = formEl.classList.contains('open');
      // close all forms first
      var allForms = document.querySelectorAll('.occ-form');
      for (var f = 0; f < allForms.length; f++) allForms[f].classList.remove('open');
      // toggle this one
      if (!wasOpen) {
        formEl.classList.add('open');
        setTimeout(function(){ formEl.scrollIntoView({behavior:'smooth',block:'center'}); }, 300);
      }
      return;
    }

    var gotoEl = findAttr(node, 'data-goto');
    if (gotoEl) {
      e.preventDefault();
      if (gotoEl.getAttribute('data-close-nav')) mobileNav.classList.remove('open');
      goTo(gotoEl.getAttribute('data-goto'), gotoEl.getAttribute('data-scroll') || undefined);
      return;
    }

    var qtyEl = findAttr(node, 'data-qty');
    if (qtyEl) {
      e.preventDefault();
      var wrap = qtyEl.parentNode;
      var n = wrap.querySelector('.o-qty-num') || wrap.querySelector('.ln-qty-num');
      if (n) {
        var v = parseInt(n.textContent, 10) + parseInt(qtyEl.getAttribute('data-qty'), 10);
        if (v < 1) v = 1; if (v > 20) v = 20;
        n.textContent = v;
      }
      return;
    }

    var submitEl = findAttr(node, 'data-submit');
    if (submitEl) {
      e.preventDefault();
      var tp = submitEl.getAttribute('data-submit');

      var payload, fieldsId, doneId;
      if (tp === 'wedding') {
        payload = {
          _subject: 'Layers Wedding Enquiry',
          Enquiry_Type: 'Wedding',
          Name: (document.getElementById('w-name')||{}).value || '',
          Email: (document.getElementById('w-email')||{}).value || '',
          Phone: (document.getElementById('w-phone')||{}).value || '',
          Wedding_Date: (document.getElementById('w-date')||{}).value || '',
          Number_of_Guests: (document.getElementById('w-guests')||{}).value || '',
          Message: (document.getElementById('w-message')||{}).value || ''
        };
        fieldsId = 'weddingFields'; doneId = 'weddingDone';
      } else if (tp === 'gathering') {
        payload = {
          _subject: 'Layers Gathering Enquiry',
          Enquiry_Type: 'Gathering',
          Name: (document.getElementById('g-name')||{}).value || '',
          Email: (document.getElementById('g-email')||{}).value || '',
          Phone: (document.getElementById('g-phone')||{}).value || '',
          Event_Type: (document.getElementById('g-type')||{}).value || '',
          Number_of_Guests: (document.getElementById('g-guests')||{}).value || '',
          Message: (document.getElementById('g-message')||{}).value || ''
        };
        fieldsId = 'gatheringFields'; doneId = 'gatheringDone';
      } else if (tp === 'review') {
        payload = {
          _subject: 'Layers Customer Review',
          Rating: (selectedRating ? selectedRating + ' / 5 stars' : 'Not given'),
          Name: (document.getElementById('rev-name')||{}).value || '',
          Review: (document.getElementById('rev-text')||{}).value || ''
        };
        fieldsId = 'reviewFields'; doneId = 'reviewDone';
      }

      // Show confirmation immediately
      document.getElementById(fieldsId).style.display = 'none';
      document.getElementById(doneId).classList.add('show');

      // Send to email via Formspree
      try {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', 'https://formspree.io/f/mbdvrvqw', true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.send(JSON.stringify(payload));
      } catch (err) {}
      return;
    }

    if (findMatch(node, function(x){ return hasId(x,'menuToggle'); })) { mobileNav.classList.add('open'); return; }
    if (findMatch(node, function(x){ return hasId(x,'menuClose') || hasClass(x,'mobile-nav-close'); })) { mobileNav.classList.remove('open'); return; }
    if (findMatch(node, function(x){ return hasClass(x,'logo-container'); })) { e.preventDefault(); goTo('home'); return; }
  });

  // Spoon-pull image: gentle zoom-out as it scrolls up through the viewport
  var zoomEl = document.getElementById('zoomSpoon');
var zoomCocoa = document.getElementById('zoomCocoa');
  function updateZoom() {
    if (!zoomEl) return;
    var r = zoomEl.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var center = r.top + r.height / 2;
    var ratio = center / vh;            // 1 = bottom of screen, 0 = top
    var progress = 1 - ratio;           // 0 at bottom, 1 at top
    if (progress < 0) progress = 0;
    if (progress > 1) progress = 1;
    var scale = 1.22 - 0.22 * progress; // starts zoomed in (1.22), eases out to 1.0
    zoomEl.style.transform = 'scale(' + scale.toFixed(4) + ')'; if (zoomCocoa) { var r2 = zoomCocoa.getBoundingClientRect(); var p2 = 1 - ((r2.top + r2.height/2)/vh); if (p2<0) p2=0; if (p2>1) p2=1; zoomCocoa.style.transform = 'scale(' + (1.22 - 0.22*p2).toFixed(4) + ')'; }
  }

  window.addEventListener('scroll', function() {
    updateZoom();
    if (header.classList.contains('force-solid')) return;
    var y = window.scrollY || window.pageYOffset;
    if (y > 20) announcement.classList.add('hidden'); else announcement.classList.remove('hidden');
    if (y > 5) header.classList.add('scrolled'); else header.classList.remove('scrolled');
  });
  updateZoom();

  // Any video with class "slowmo" plays at half speed (slow motion)
  function initSlowMo() {
    var vids = document.querySelectorAll('video.slowmo');
    for (var v = 0; v < vids.length; v++) {
      (function(vid){
        vid.playbackRate = 0.5;
        vid.addEventListener('loadedmetadata', function(){ vid.playbackRate = 0.5; });
        var p = vid.play(); if (p && p.catch) p.catch(function(){});
      })(vids[v]);
    }
  }
  initSlowMo();
  
(function(){ var abs = document.querySelectorAll('button[data-add]'); for (var i = 0; i < abs.length; i++) { var src = abs[i]; if (src.parentNode.querySelector('.buy-now')) continue; var buy = document.createElement('button'); buy.type = 'button'; buy.className = 'btn-outline buy-now'; buy.setAttribute('data-buynow', '1'); buy.textContent = 'Buy Now'; src.parentNode.insertBefore(buy, src.nextSibling); } })();

  // Reviews: show the slider only when real reviews exist
  var revTrack = document.getElementById('reviewsTrack');
  if (revTrack) {
    var hasReviews = revTrack.querySelectorAll('.r-card').length > 0;
    revTrack.style.display = hasReviews ? 'flex' : 'none';
  }

  var fadeEls = document.querySelectorAll('.fade-in');
  if (window.IntersectionObserver) {
    var observer = new IntersectionObserver(function(entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) { entries[i].target.classList.add('visible'); observer.unobserve(entries[i].target); }
      }
    }, { threshold: 0, rootMargin: '0px 0px -25% 0px' });
    for (var j = 0; j < fadeEls.length; j++) observer.observe(fadeEls[j]);
  } else {
    for (var k = 0; k < fadeEls.length; k++) fadeEls[k].classList.add('visible');
  }
})();

/* ==========================================================================
   LAYERS -- conversion add-ons
   Paste this block at the VERY END of layers.js. Nothing above it changes.

   Covers: size bracket after every product name - delivery line under
           every price - per-cup price on bundles - sticky mobile buy bar

   Why this is JavaScript and not markup: your products appear three times
   (home slider, Order page, Late Nights) plus the bundle cards, and the
   bundle prices change when someone toggles flavour. Doing it here means
   every price gets the same line, and the per-cup figure can never go stale.
   ========================================================================== */
(function () {
  'use strict';

  /* Shown in brackets after the name. "Little Italy" and "Dolce Vita" are
     lovely names but they tell nobody which one is bigger, and a customer who
     can't tell two options apart usually picks neither.
     The word and the number together do the whole job on one line -- "Small"
     is instant, "250ml" is checkable, and 250 against 350 needs no explaining.
     Edit the text here and it changes everywhere on the site at once. */
  var SIZE_LABEL = {
    'Little Italy': 'Small &middot; 250ml',
    'Dolce Vita':   'Medium &middot; 350ml'
  };

  /* The delivery line shown under every price. Zone is bound to the claim
     on purpose -- free shipping is New Cairo only. */
  var SHIP_LINE = 'Delivery from EGP 50 &middot; <strong>free in New Cairo over EGP 500</strong>';

  /* Shown instead on any card that already clears the threshold. A EGP 648 box
     telling you "free over EGP 500" makes you do arithmetic to discover a
     benefit you already have. */
  var FREE_OVER = 500;
  var SHIP_FREE = '<strong>Free delivery in New Cairo</strong>';

  /* What the sticky phone bar offers -- the cheapest way in. */
  var ENTRY = { name: 'Little Italy', price: 180 };

  var PHONE_MAX = 900;

  /* ---------------------------------------------------------------- */

  function el(tag, cls, html) {
    var d = document.createElement(tag);
    if (cls) d.className = cls;
    if (html != null) d.innerHTML = html;
    return d;
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---- 11 - delivery line under every price ----------------------- */

  var PRICE_SEL = '.p-price, .o-item-price, .ln-item-price, .bundle-price-row';

  /* what this card actually charges -- on a bundle row that's the live price,
     not the struck-through "was" sitting beside it */
  function priceOf(p) {
    var node = p.classList.contains('bundle-price-row')
      ? (p.querySelector('.bundle-price') || p)
      : p;
    var m = node.textContent.replace(/,/g, '').match(/(\d+(?:\.\d+)?)/);
    return m ? parseFloat(m[1]) : 0;
  }

  function addShipLines() {
    document.querySelectorAll(PRICE_SEL).forEach(function (p) {
      var host = p.parentElement;
      if (!host) return;

      var line = host.querySelector(':scope > .p-ship');
      if (!line) {
        line = el('p', 'p-ship', '');
        var anchor = host.querySelector(':scope > .p-percup') || p;
        anchor.insertAdjacentElement('afterend', line);
      }
      line.innerHTML = priceOf(p) >= FREE_OVER ? SHIP_FREE : SHIP_LINE;
    });
  }

  /* ---- size bracket after the product name ------------------------ */

  var NAME_SEL = '.p-name, .o-item-name, .ln-item-name';

  /* reads the product name with any bracket we've added stripped back out,
     so re-running this never sees "Little Italy (Small)" as a new product */
  function cleanName(node) {
    if (!node) return '';
    var copy = node.cloneNode(true);
    copy.querySelectorAll('.p-size-tag').forEach(function (x) { x.remove(); });
    return copy.textContent.trim();
  }

  function addSizeLabels() {
    document.querySelectorAll(NAME_SEL).forEach(function (n) {
      if (n.querySelector('.p-size-tag')) return;
      var label = SIZE_LABEL[cleanName(n)];
      if (!label) return;
      n.appendChild(document.createTextNode(' '));
      n.appendChild(el('span', 'p-size-tag', '(' + label + ')'));
    });
  }

  /* Same bracket inside the bundle chooser. The label above those buttons
     already says "Choose your size", then offers "4x Little Italy" and
     "4x Dolce Vita" -- which is the exact spot where the size question goes
     unanswered. Appends only; the existing button text is left alone. */
  function addBundleSizeLabels() {
    document.querySelectorAll('.bundle-flavor-btn').forEach(function (b) {
      if (b.querySelector('.p-size-tag')) return;
      var m = cleanName(b).match(/^\d+\s*x\s*(.+)$/i);
      if (!m) return;
      var label = SIZE_LABEL[m[1].trim()];
      if (!label) return;
      b.appendChild(document.createTextNode(' '));
      b.appendChild(el('span', 'p-size-tag', '(' + label + ')'));
    });
  }

  /* ---- per-cup price on the bundles -------------------------------
     EGP 918 reads as a big number. EGP 153 a cup reads as a saving.
     Recalculated whenever the flavour toggle changes the price.        */

  function bundlePerCup() {
    document.querySelectorAll('.bundle-card').forEach(function (card) {
      var btn = card.querySelector('[data-add][data-price]');
      if (!btn) return;

      var packs = (btn.getAttribute('data-add') || '').match(/(\d+)\s*x/i);
      var n     = packs ? parseInt(packs[1], 10) : 0;
      var price = parseFloat(btn.getAttribute('data-price') || '0');
      if (!n || !price) return;

      var per  = price / n;
      var text = 'EGP ' + (per % 1 === 0 ? per : per.toFixed(2)) + ' per cup';

      var line = card.querySelector('.p-percup');
      if (!line) {
        var row = card.querySelector('.bundle-price-row');
        if (!row) return;
        line = el('p', 'p-percup', '');
        row.insertAdjacentElement('afterend', line);
      }
      line.textContent = text;
    });
  }

  function watchBundles() {
    document.querySelectorAll('.bundle-card [data-add][data-price]').forEach(function (btn) {
      new MutationObserver(bundlePerCup)
        .observe(btn, { attributes: true, attributeFilter: ['data-price', 'data-add'] });
    });
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.bundle-flavor-btn')) {
        setTimeout(function () {
          bundlePerCup();
          addShipLines();          /* price changed, so the delivery line may too */
          addBundleSizeLabels();   /* in case the toggle rewrote the labels */
        }, 40);
      }
    });
  }

  /* ---- 13 - sticky buy bar (phones, home page only) ---------------- */

  var bar = null;

  function buildBar() {
    if (document.querySelector('.sticky-buy')) return;

    bar = el('div', 'sticky-buy',
      '<div class="sticky-buy-info">' +
        '<div class="sticky-buy-name">' + ENTRY.name + ' &mdash; EGP ' + ENTRY.price + '</div>' +
        '<div class="sticky-buy-sub">Same day &middot; delivered 4PM&ndash;1AM</div>' +
      '</div>' +
      '<button type="button" class="btn-primary sticky-buy-btn">Add to Cart</button>');

    document.body.appendChild(bar);

    /* Clicks the real button rather than duplicating your cart code, so it
       behaves identically to tapping Add to Cart on the card itself. */
    bar.querySelector('.sticky-buy-btn').addEventListener('click', function () {
      var sel  = '[data-add="' + ENTRY.name + '"]';
      var real = document.querySelector('.page.active ' + sel) || document.querySelector(sel);
      if (real) real.click();
    });
  }

  function activePageId() {
    var p = document.querySelector('.page.active');
    return p ? p.id : '';
  }

  function update() {
    if (!bar) return;

    var phone  = window.innerWidth <= PHONE_MAX;
    var onHome = activePageId() === 'page-home';

    /* the .page check is what keeps this off the FAQ, Order and Late
       Nights views -- it is a single-page app, so a plain sticky element
       would otherwise float over all of them */
    document.body.classList.toggle('sticky-on', phone && onHome);
    if (!phone || !onHome) { bar.classList.remove('show'); return; }

    var hero = document.querySelector('.hero');
    var y    = window.scrollY || window.pageYOffset || 0;
    var past = hero ? y > hero.offsetHeight * 0.85 : y > 400;

    var foot = document.querySelector('footer, .footer, .site-footer');
    var atFooter = foot ? foot.getBoundingClientRect().top < window.innerHeight - 40 : false;

    bar.classList.toggle('show', past && !atFooter);
  }

  function watchPages() {
    var refresh = function () {
      update();
      addShipLines();
      addSizeLabels();
      addBundleSizeLabels();
      bundlePerCup();
    };
    var mo = new MutationObserver(refresh);
    document.querySelectorAll('.page').forEach(function (p) {
      mo.observe(p, { attributes: true, attributeFilter: ['class'] });
    });
  }

  /* ---- go ---------------------------------------------------------- */

  ready(function () {
    addShipLines();
    addSizeLabels();
    addBundleSizeLabels();
    bundlePerCup();
    watchBundles();
    buildBar();
    watchPages();
    update();

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-goto]')) setTimeout(update, 80);
    });
  });

})();

/* ==========================================================================
   FIRST-ORDER POPUP
   Paste this at the VERY END of layers.js, after everything else.

   WHAT IT CAN AND CANNOT KNOW -- read this once, it matters:

   Your checkout is guest checkout, and the Shopify thank-you page does not
   run this file. So nothing on the storefront can truly know "this person has
   ordered before". What it CAN know is what this browser has done:

     - dismissed or claimed the code   -> never shown again
     - clicked through to checkout     -> never shown again

   That covers the realistic cases. Someone who ordered last month on their
   phone and comes back on the same phone will not see it. Someone who ordered
   and then visits on a brand-new device will see it once -- and if they try
   the code, Shopify rejects it anyway, because FIRSTBITE is already set to
   "one use per customer". So the discount can never actually be used twice;
   the popup is just occasionally shown to someone who no longer needs it.

   If you ever want this airtight, the fix is on Shopify's side, not here:
   require accounts at checkout, or run the popup through an email-capture app
   that knows your customer list.
   ========================================================================== */
(function () {
  'use strict';

  /* ---- things you might want to change ---------------------------- */
  var CODE     = 'FIRSTBITE';
  var HEADLINE = '15% off your first LAYERS.';
  var SUB      = 'Same-day delivery across Greater Cairo. Free in New Cairo on orders over EGP 500.';
  var DELAY_MS = 6000;   /* set to 0 to fire the instant the page loads */

  var KEY_SEEN   = 'layers_fb_seen';     /* dismissed or claimed the code */
  var KEY_BOUGHT = 'layers_reached_checkout';

  /* ---------------------------------------------------------------- */

  /* localStorage throws in some private-browsing modes -- never let that
     break the page, just fall back to showing the popup once per visit */
  function get(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function set(k) { try { localStorage.setItem(k, '1'); } catch (e) {} }

  /* anyone who has gone to checkout from this browser stops seeing it */
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest &&
        e.target.closest('.buy-now, [data-checkout], a[href*="/checkout"]')) {
      set(KEY_BOUGHT);
    }
  });

  if (get(KEY_SEEN) || get(KEY_BOUGHT)) return;

  var overlay = null, shown = false, dismissed = false;

  function build() {
    overlay = document.createElement('div');
    overlay.className = 'fb-overlay';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.innerHTML =
      '<div class="fb-card">' +
        '<button type="button" class="fb-close" aria-label="Close">&times;</button>' +
        '<p class="fb-eyebrow">Your first order</p>' +
        '<h2 class="fb-title">' + HEADLINE + '</h2>' +
        '<p class="fb-sub">' + SUB + '</p>' +
        '<div class="fb-code" role="button" tabindex="0">' +
          '<span class="fb-code-val">' + CODE + '</span>' +
          '<span class="fb-code-hint">Tap to copy</span>' +
        '</div>' +
        '<p class="fb-copied"></p>' +
        '<button type="button" class="btn-primary fb-cta">Start my order</button>' +
        '<br><button type="button" class="fb-no">No thanks</button>' +
      '</div>';
    document.body.appendChild(overlay);

    var copied = overlay.querySelector('.fb-copied');

    function copy() {
      set(KEY_SEEN);
      var done = function () { copied.textContent = 'Copied. Paste it at checkout.'; };
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(CODE).then(done, function () {
            copied.textContent = 'Code: ' + CODE;
          });
          return;
        }
      } catch (e) {}
      copied.textContent = 'Code: ' + CODE;
    }

    overlay.querySelector('.fb-code').addEventListener('click', copy);
    overlay.querySelector('.fb-close').addEventListener('click', close);
    overlay.querySelector('.fb-no').addEventListener('click', close);

    overlay.querySelector('.fb-cta').addEventListener('click', function () {
      copy();
      close();
      var order = document.querySelector('[data-goto="order"]');
      if (order) setTimeout(function () { order.click(); }, 220);
    });

    /* click the dark area, or press Escape */
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('open')) close();
    });
  }

  function open() {
    if (shown || dismissed || get(KEY_SEEN) || get(KEY_BOUGHT)) return;

    /* If they have tabbed away, wait. A popup that fires into a hidden tab
       spends its one chance on nobody. */
    if (document.hidden) {
      document.addEventListener('visibilitychange', function once() {
        document.removeEventListener('visibilitychange', once);
        open();
      });
      return;
    }

    shown = true;
    if (!overlay) build();
    overlay.classList.add('open');

    /* setTimeout rather than requestAnimationFrame on purpose: rAF is paused
       in background tabs, which would leave this open at zero opacity -- an
       invisible sheet covering the page. */
    setTimeout(function () { overlay.classList.add('show'); }, 20);
  }

  function close() {
    dismissed = true;
    set(KEY_SEEN);
    if (!overlay) return;
    overlay.classList.remove('show');
    setTimeout(function () { overlay.classList.remove('open'); }, 300);
  }

  function start() {
    /* whichever comes first: the timer, or them scrolling past the hero.
       Someone who scrolls is already interested, and that is a better moment
       to interrupt than the second the page appears. */
    setTimeout(open, DELAY_MS);

    var hero = document.querySelector('.hero');
    var trigger = hero ? hero.offsetHeight * 0.75 : 400;
    var onScroll = function () {
      if ((window.scrollY || window.pageYOffset || 0) > trigger) {
        window.removeEventListener('scroll', onScroll);
        open();
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);

})();
